import {
  Button,
  FormDescription,
  FormHeading,
  PageMainContent,
  ScreenTooltip,
  useGoBack,
  StyledTextLink,
} from "@vixi/ui";
import { useTranslation } from "@vixi/localization";
import { Avatar } from "@vixi/types";
import { FC } from "react";
import { Img } from "@vixi/ui";

interface ReviewCharacterStepProps {
  avatars: Avatar[];
  onNext: () => void;
}

export const ReviewCharacterStep: FC<ReviewCharacterStepProps> = ({ avatars, onNext }) => {
  useGoBack(null);
  const { t } = useTranslation();

  return (
    <PageMainContent className="flex flex-col justify-center items-center ">
      <FormHeading className="flex flex-col justify-center items-center" heading="CreateAvatar.HereIsYourNewCharacter" showDivider={false}>
        <div className="flex items-end gap-3">
          <FormDescription className="mt-2.75">
            {t("CreateAvatar.HereAreYourNewCharactersDescription")}
          </FormDescription>
          <ScreenTooltip image="/images/screens/avatar-in-course.png">
            <StyledTextLink>{t("Action.SeeHow")}</StyledTextLink>
          </ScreenTooltip>
        </div>
      </FormHeading>

      <div className="flex flex-[0.8] items-center justify-center gap-19.5">
        {avatars.map((avatar, i) => (
          <div className="bg-paper aspect-185/336 h-auto max-h-[50vh] min-w-46.25 rounded" key={i}>
            <Img src={avatar.url} alt="avatar" className="h-full w-full" />
          </div>
        ))}
      </div>

      <div className="fixed right-22.5 bottom-12.5">
        <Button variant="contained" color="primary" size="large" onClick={onNext}>
          {t("Action.Next")}
        </Button>
      </div>
    </PageMainContent>
  );
};
